import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { toolkitTestIds } from "../../../constants";
import Text from "../Text";
/**
 * The Heading component provides semantic HTML heading elements with customizable styles.
 *
 * @component
 *
 * @param {IHeadingProps} props - The component props.
 * @param {THeadingTags} props.tag - The HTML tag for the heading element. One of: "h1", "h2", "h3", "h4", "h5", or "h6".
 * @param {"2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl"} [props.size="3xl"] - The font size of the heading.
 * @param {"normal" | "medium" | "semibold" | "bold" | "extrabold" | "black"} [props.weight="bold"] - The font weight of the heading.
 * @param {React.ReactNode} [props.children] - The content of the heading.
 * @param {string} [props.className] - An optional CSS class name to apply to the heading.
 * @param {string} [props.color] - The font color of the heading.
 * @param {string} [props.id] - The ID of the heading.
 * @param {string} [props.testId="heading"] - The test id attribute for the heading.
 * @param {React.RefObject<HTMLElement>} forwardedRef - A ref object for the heading.
 * @returns {JSX.Element} The rendered Heading component.
 */
const Heading = ({ children, size = "3xl", tag, testId = toolkitTestIds.heading, weight = "bold", ...headingProps }, forwardedRef) => {
    return (_jsx(Text, { ...headingProps, role: "heading", size: size, tag: tag, testId: testId, weight: weight, ref: forwardedRef, children: children }));
};
export default forwardRef(Heading);
//# sourceMappingURL=Heading.js.map